import SuperFetch from 'library/helpers/superFetch';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { Notification } from 'zComponents/atoms';
import { categoriesActions } from './slice';

// Sagas
export function* getCategories() {
	try {
		// Get the orgID from the selected profile
		const { orgID } = yield select((state) => state.Auth.selectedProfile);

		// Get categories from the current organisation.
		const categories = yield call(() => SuperFetch.get('/deviceCategories', {}, { includeFields: true }));
		if (categories.statusCode === 200) {
			yield put(categoriesActions.loadCategoriesSuccess({ orgID, data: categories.data }));
		} else {
			throw Error(categories.error.message || 'Failed to load categories.');
		}
	} catch (error) {
		yield put(categoriesActions.loadCategoriesError(error));
	}
}

export function* getAllCategoryFields() {
	try {
		// ✅ Get orgID
		const { orgID } = yield select((state) => state.Auth.selectedProfile);

		const categoryFields = yield call(() => SuperFetch.get('/deviceCategories/getAllFields'));

		if (categoryFields.statusCode === 200) {
			yield put(categoriesActions.loadAllCategoryFieldsSuccess({ orgID, data: categoryFields.data }));
		} else {
			throw Error(categoryFields.error.message || 'Failed to load category fields.');
		}
	} catch (error) {
		yield put(categoriesActions.loadAllCategoryFieldsError(error));
	}
}

export function* createDefaultCategory(action) {
	// Get data from the payload.
	const { defaultCategoryID, name } = action.payload;

	try {
		// Create the default category with the new data.
		const category = yield call(() =>
			SuperFetch.post('/deviceCategories/defaultCategories/createManualCategory', {
				defaultCategoryID,
				name
			})
		);
		if (category.statusCode === 201) {
			yield put(categoriesActions.createCategorySuccess());
			Notification('success', 'Default category created successfully.');
		} else {
			throw Error(category.error || category.error.message || 'Failed to create category.');
		}
	} catch (error) {
		yield put(categoriesActions.createCategoryError(error));
		Notification('error', error.message);
	}
}

export function* createCategory({ payload }) {
	try {
		const { data, fields = [] } = payload;

		// Create the category with the new data.
		const category = yield call(() => SuperFetch.post('/deviceCategories', { ...data, fields }));

		if (category.statusCode === 201 || category.statusCode === 200) {
			yield put(categoriesActions.createCategorySuccess());
			Notification('success', 'Category created successfully.');
		} else {
			throw Error(category.error || category.error.message || 'Failed to create category.');
		}
	} catch (error) {
		yield put(categoriesActions.createCategoryError(error));
		Notification('error', error.message);
	}
}

// Actions after create a category. 🔥 Add here!!!!!.
export function* createCategorySuccess() {
	yield put(categoriesActions.loadCategories());
}

export function* updateCategory({ payload }) {
	try {
		// Get categoryID and data from the payload.
		const { categoryID, data } = payload;

		// Update the category with the new data.
		const category = yield call(() => SuperFetch.patch(`/deviceCategories/${categoryID}`, data));
		if (category.statusCode === 200) {
			yield put(categoriesActions.updateCategorySuccess());
			Notification('success', 'Category has been updated successfully.');
		} else {
			throw Error(category.error.message || 'Failed to update category.');
		}
	} catch (error) {
		yield put(categoriesActions.updateCategoryError(error));
		Notification('error', error.message);
	}
}

// Actions after update a category. 🔥 Add here!!!!!.
export function* updateCategorySuccess() {
	yield put(categoriesActions.loadCategories());
}

export function* deleteCategory({ payload }) {
	try {
		// Get categoryID from the payload.
		const { categoryID } = payload;

		// Delete the category.
		const category = yield call(() => SuperFetch.delete(`/deviceCategories/${categoryID}`));
		if (category.statusCode === 200) {
			yield put(categoriesActions.deleteCategorySuccess());
			Notification('success', 'Category deleted successfully.');
		} else {
			throw Error(category.error.message || 'Failed to delete category.');
		}
	} catch (error) {
		yield put(categoriesActions.deleteCategoryError(error));
		Notification('error', error.message);
	}
}

// Actions after delete a category. 🔥 Add here!!!!!.
export function* deleteCategorySuccess() {
	yield put(categoriesActions.loadCategories());
}

export function* getCategoryFields({ payload }) {
	try {
		// Get the orgID from the selected profile
		const { orgID } = yield select((state) => state.Auth.selectedProfile);
		const { categoryID } = payload;

		// Get fields from the selected category.
		const fields = yield call(() => SuperFetch.get(`/deviceCategories/${categoryID}/fields`));

		if (fields.statusCode === 200) {
			yield put(categoriesActions.loadCategoryFieldsSuccess({ orgID, categoryID, fields: fields.data }));
		} else {
			throw Error(fields.error.message || 'Failed to load category fields.');
		}
	} catch (error) {
		yield put(categoriesActions.loadCategoryFieldsError(error));
	}
}

export function* createCategoryField({ payload }) {
	try {
		// Get categoryID and data from the payload.
		const { categoryID, data } = payload;

		// Create the field with the new data.
		const field = yield call(() => SuperFetch.post(`/deviceCategories/${categoryID}/fields`, data));

		if (field.statusCode === 201 || field.statusCode === 200) {
			yield put(categoriesActions.createCategoryFieldSuccess({ categoryID }));
			Notification('success', 'Field created successfully.');
		} else {
			throw Error(field.error.message || 'Failed to create field.');
		}
	} catch (error) {
		yield put(categoriesActions.createCategoryFieldError(error));
		Notification('error', error.message);
	}
}

// Actions after create a field. 🔥 Add here!!!!!.
export function* createCategoryFieldSuccess(action) {
	const { categoryID } = action.payload;

	yield put(categoriesActions.loadCategoryFields({ categoryID }));
}

export function* updateField({ payload }) {
	try {
		// Get categoryID, fieldID and data from the payload.
		const { categoryID, fieldID, data } = payload;

		// Update the fields from the category.
		const category = yield call(() => SuperFetch.patch(`/deviceCategories/${categoryID}/fields/${fieldID}`, data));
		if (category.statusCode === 200) {
			yield put(categoriesActions.updateCategoryFieldSuccess({ categoryID }));
			Notification('success', 'Field updated successfully.');
		} else {
			throw Error(category.error.message || 'Failed to update field.');
		}
	} catch (error) {
		yield put(categoriesActions.updateCategoryFieldError(error));
		Notification('error', error.message);
	}
}

// Actions after update a field. 🔥 Add here!!!!!.
export function* updateCategoryFieldSuccess(action) {
	const { categoryID } = action.payload;

	yield put(categoriesActions.loadCategoryFields({ categoryID }));
}

export function* deleteField({ payload }) {
	try {
		// Get categoryID and fieldID from the payload.
		const { categoryID, fieldID } = payload;

		// Delete the field from the category.
		const category = yield call(() => SuperFetch.delete(`/deviceCategories/${categoryID}/fields/${fieldID}`));
		if (category.statusCode === 200) {
			yield put(categoriesActions.deleteCategoryFieldSuccess({ categoryID }));
			Notification('success', 'Field deleted successfully.');
		} else {
			throw Error(category.error.message || 'Failed to delete field.');
		}
	} catch (error) {
		yield put(categoriesActions.deleteFieldError(error));
		Notification('error', error.message);
	}
}

// Actions after delete a field. 🔥 Add here!!!!!.
export function* deleteFieldSuccess(action) {
	const { categoryID } = action.payload;

	yield put(categoriesActions.loadCategoryFields({ categoryID }));
}

export default function* categoriesSaga() {
	yield takeLatest(categoriesActions.loadCategories, getCategories);
	yield takeLatest(categoriesActions.loadAllCategoryFields, getAllCategoryFields);
	yield takeLatest(categoriesActions.createDefaultCategory, createDefaultCategory);
	yield takeLatest(categoriesActions.createCategory, createCategory);
	yield takeLatest(categoriesActions.createCategorySuccess, createCategorySuccess);
	yield takeLatest(categoriesActions.updateCategory, updateCategory);
	yield takeLatest(categoriesActions.updateCategorySuccess, updateCategorySuccess);
	yield takeLatest(categoriesActions.deleteCategory, deleteCategory);
	yield takeLatest(categoriesActions.deleteCategorySuccess, deleteCategorySuccess);
	yield takeLatest(categoriesActions.loadCategoryFields, getCategoryFields);
	yield takeLatest(categoriesActions.createCategoryField, createCategoryField);
	yield takeLatest(categoriesActions.createCategoryFieldSuccess, createCategoryFieldSuccess);
	yield takeLatest(categoriesActions.updateCategoryField, updateField);
	yield takeLatest(categoriesActions.updateCategoryFieldSuccess, updateCategoryFieldSuccess);
	yield takeLatest(categoriesActions.deleteCategoryField, deleteField);
	yield takeLatest(categoriesActions.deleteCategoryFieldSuccess, deleteFieldSuccess);
}
